import Typography from "components/typography";
import React from "react";
import styled from "styled-components";
import { Colors } from "utils/colors";
import { ReactComponent as QuestionMark } from "images/svg/questionMark.svg";

const Why = () => {
  return (
    <Container>
      <LeftSide data-aos="fade-right">
        <Typography size="4rem" weight="bold" mb="2" m_mb="2.6">
          Why We Are Different?
        </Typography>
        <Item>
          <Typography
            size="xl"
            weight="semibold"
            color={Colors.yellow400}
            mb="1"
            m_size="m"
          >
            • Built for African Creators
          </Typography>
          <Typography
            size="xl"
            color={Colors.grey400}
            lh="2.8"
            m_size="m"
            m_lh="2.4"
          >
            Rated Afrika is designed to meet the specific needs of African
            artists, from the way we structure royalty payments to the platforms
            we distribute to.
          </Typography>
        </Item>
        <Item>
          <Typography
            size="xl"
            weight="semibold"
            color={Colors.yellow400}
            mb="1"
            m_size="m"
          >
            • Fairness and Transparency
          </Typography>
          <Typography
            size="xl"
            color={Colors.grey400}
            lh="2.8"
            m_size="m"
            m_lh="2.4"
          >
            We value fair compensation and believe in supporting our artists
            through clear, straightforward royalty management tools that keep
            everyone in the loop.
          </Typography>
        </Item>
        <Item>
          <Typography
            size="xl"
            weight="semibold"
            color={Colors.yellow400}
            mb="1"
            m_size="m"
          >
            • Empowering Growth
          </Typography>
          <Typography
            size="xl"
            color={Colors.grey400}
            lh="2.8"
            m_size="m"
            m_lh="2.4"
          >
            We value fair compensation and believe in supporting our artists We
            offer all creators from emerging artists to established names the
            same high-quality tools and support to help them reach their full
            potential
          </Typography>
        </Item>
      </LeftSide>
      <Icon data-aos="fade-left">
        <QuestionMark />
      </Icon>
    </Container>
  );
};

export default Why;

const Container = styled.div`
  padding: 6.5rem 10.4rem;
  display: flex;
  align-items: start;
  justify-content: space-between;

  @media only screen and (max-width: 769px) {
    flex-direction: column;
    padding: 4.8rem 2rem;
    align-items: center;
    gap: 4.4rem;
  }
`;

const LeftSide = styled.div`
  width: 45%;
  @media only screen and (max-width: 769px) {
    width: 100%;
  }
`;

const Item = styled.div`
  margin-top: 1rem;
  @media only screen and (max-width: 769px) {
    margin-top: 2rem;
  }
`;

const Icon = styled.div`
  width: 38rem;
  @media only screen and (max-width: 769px) {
    width: 80%;
  }
`;
